import http, { Http } from '@/lib/http';

interface User {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  createdAt: Date;
}

interface Projects {
  id: string;
  name: string;
  createdAt: Date;
}

export interface AppState {
  user: User;
  projects: Projects[];
}

function getAppStateCtor(http: Http) {
  return async () => {
    const { data } = await http.get<AppState>('/app/v2/state');
    return data;
  };
}

export const getAppState = getAppStateCtor(http);
